export const Images = {
    pairs: require('../src/assets/images/pairs.svg').default,
    exchanger: require('../src/assets/images/exchanger.svg').default,
    opportunity: require('../src/assets/images/opportunity.svg').default,
    users: require('../src/assets/images/users.svg').default,
} 